import axios from 'axios';
import humps from 'humps';
import OMSError from './error';
var createRequest = function createRequest(config) {
  var headers = {
    'Content-Type': 'application/json'
  };
  if (config.storeSlug) {
    headers['ACS-Store'] = config.storeSlug;
  }
  var client = axios.create({
    baseURL: config.domain,
    headers: headers
  });
  client.interceptors.response.use(function (response) {
    if (response !== null && response !== void 0 && response.data) {
      response.data = humps.camelizeKeys(response.data);
    }
    return response;
  }, function (error) {
    var _error$response, _error$response2, _error$response3;
    if ((_error$response = error.response) !== null && _error$response !== void 0 && _error$response.data) {
      /* eslint-disable-next-line no-param-reassign */
      error.response.data = humps.camelizeKeys(error.response.data);
    }
    var message = error.toString();
    var status = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status;
    var data = (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data;
    return Promise.reject(new OMSError(message, status, data));
  });
  client.interceptors.request.use(function (request) {
    var _request$config;
    if (request !== null && request !== void 0 && request.data) {
      request.data = humps.decamelizeKeys(request.data);
    }
    if (request !== null && request !== void 0 && (_request$config = request.config) !== null && _request$config !== void 0 && _request$config.params) {
      request.config.params = humps.decamelizeKeys(request.config.params);
    }
    return request;
  }, function (error) {
    return Promise.reject(error);
  });
  return client;
};
export default createRequest;